import { render, staticRenderFns } from "./info-item-pop.vue?vue&type=template&id=98f285da&"
import script from "./info-item-pop.vue?vue&type=script&lang=js&"
export * from "./info-item-pop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports